import LogoImage from '../../resources/Logo_Poderosas.png';

const Header = () => {
    return <a
    className='cursor-pointer col-start-2'
    href={process.env.REACT_APP_PODEROSAS_URL}
>
    <img
        className='mx-auto h-[100px]'
        src={LogoImage}
        alt='Poderosas Logo Red'
    />
</a>
}

export default Header